import type { PointArray } from '../types/contour-definition-array-type';

import { booleanWithin } from '@turf/turf';

import { pointArrayToPolygon } from './turf-utils';

/**
 * Checks if one polygon is completely within another polygon.
 *
 * @param childPolygon - An array of points representing the first polyline.
 * @param parentPolygon - An array of points representing the second polyline.
 * @returns True if the first polygon is completely within the second; otherwise, false.
 */
export function isPolygonInside(
  childPolygon: PointArray,
  parentPolygon: PointArray,
): boolean {
  if (childPolygon.length < 4 || parentPolygon.length < 4) {
    return false;
  }
  const poly1 = pointArrayToPolygon(childPolygon);
  const poly2 = pointArrayToPolygon(parentPolygon);

  const isWithin = booleanWithin(poly1, poly2);

  return isWithin;
}
